export default __webpack_public_path__ + "images/Dr.Ci.Labo.png";